import NullComponent from './NullComponent';

export default NullComponent;
